import React, { useState } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import FormInputs from '../../../Utils/FormInputs';

export default function GstReports() {
    const initialInputData = {
        time_duration: '',
        gst_type: '',
        gst_tax: '',
        gst_tax_type: '',
        gst_report: '',
        branch_select: '',
    }

    const [inputData, setInputData] = useState(initialInputData);
    const handleGstReportsChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleGstReportsSubmit = (e) => {
        e.preventDefault();
    };
    const gstReportsRows = [
        {
            columns: [
                {
                    size: { lg: 4 }, label: 'Time Duration', type: 'select', name: 'time_duration', id: 'timeDuration', value: inputData.time_duration, errormsg: '',
                    options: [
                        { value: '', label: 'All Time' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { lg: 4 }, label: 'GST Type', type: 'select', name: 'gst_type', id: 'gstType', value: inputData.gst_type, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { lg: 4 }, label: 'GST Tax', type: 'select', name: 'gst_tax', id: 'gstTax', value: inputData.gst_tax, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { md: 6 }, label: 'GST Tax Type', type: 'select', name: 'gst_tax_type', id: 'gstTaxType', value: inputData.gst_tax_type, errormsg: '',
                    options: [
                        { value: '', label: 'Select' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { md: 6 }, label: 'GST Report', type: 'select', name: 'gst_report', id: 'gstReport', value: inputData.gst_report, errormsg: '',
                    options: [
                        { value: '', label: 'Output-Sal/Srt/Dcrt' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 12 }, label: 'Branch', type: 'multiSelect', isMulti: 'true', placeholder: 'Select provider...1', name: 'branch_select', id: 'branchSelect', value: inputData.branch_select, errormsg: '',
                    options: [
                        { value: "Test", label: "Test" },
                        { value: "Umesh bhai", label: "Umesh bhai" },
                        { value: "NSF Adajan", label: "NSF Adajan" },
                        { value: "NFS Parle Point", label: "NFS Parle Point" },
                        { value: "NFS Uniform", label: "NFS Uniform" },
                    ],
                },
            ]
        },
    ];
    const gstReportsButtons = [];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-md-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-md-0'>GST Report</Card.Title>
                                            <Form>
                                                <div className='min-sm-w'>
                                                    <Form.Select size="sm">
                                                        <option>Last Month</option>
                                                        <option value="1">One</option>
                                                        <option value="2">Two</option>
                                                    </Form.Select>
                                                </div>
                                            </Form>
                                        </div>

                                        <FormInputs Buttons={gstReportsButtons} rows={gstReportsRows} handleInputChange={handleGstReportsChange} handleSubmit={handleGstReportsSubmit} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <Card.Title>GST Report Description</Card.Title>
                                        <h5 className='fw-normal mb-3 fs-17'>All Time | Report_R-3 | All | All | Output-Sal/Srt/Dcrt</h5>
                                        <p className='text-muted mb-3'>GST R3 contains the monthly summary of sales and purchases along with tax liability. It basically consists of two parts i.e. Part A and Part B. Part A of the return is electronicallygenerated on the basis of information furnished through returns in GST
                                            R1 and GST R2, Whereas Part B contains the tax liability, interest, and penalty paid. It is considered to be important as it will only tell the GST liability of a person for a particular month. This tax liability a is person compelled to discharge.</p>
                                        <div className="div btn-list text-end">
                                            <Button variant="success">Export</Button>
                                            <Button variant="secondary">Cancel</Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
